import __vue_normalize__ from '../../../../common/temp/node_modules/.pnpm/registry.npmjs.org/vue-runtime-helpers/1.1.2/node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './TcRadioButton.vue_rollup-plugin-vue=script.js';
import './TcRadioButton.vue_rollup-plugin-vue=styles.0.css.js';

/* script */
var __vue_script__ = script;
/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tc-radio-button--wrapper",class:[
    _vm.variantClassName('tc-radio-button--wrapper'),
    _vm.wrapperType,
    _vm.disabled ? 'disabled' : ''
  ]},[_c('tc-label',{staticClass:"tc-radio-button",attrs:{"for":_vm.resolvedId}},[_c('input',_vm._g(_vm._b({attrs:{"id":_vm.resolvedId,"type":"radio","required":_vm.isRequired,"disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.isChecked}},'input',_vm.attributes,false),_vm.eventListeners)),_vm._v(" "),_c('span',{staticClass:"tc-radio-button__icon",class:_vm.variantClassName('tc-radio-button__icon')}),_vm._v(" "),_c('span',{staticClass:"tc-radio-button__content",class:_vm.variantClassName('tc-radio-button__content')},[_vm._t("default")],2),_vm._v(" "),_c('span',{staticClass:"tc-radio-button__checked"})])],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
